<script setup lang="ts">
defineProps<{
  src: string
  alt: string
}>();

defineSlots<{
  default: () => unknown
  action: () => unknown
}>();
</script>

<template>
  <IadWrapper inner-classes="rounded-2xl bg-neutral-80">
    <div class="grid md:grid-cols-2 md:gap-xl">
      <figure>
        <img
          loading="lazy"
          :src
          class="object-cover rounded-t-2xl md:rounded-tr-none md:rounded-l-2xl size-full"
          :alt
        >
      </figure>
      <div class="flex-1 flex flex-col  gap-xs md:gap-xl justify-center ps-m md:ps-0 pe-m md:pe-xl py-m">
        <slot />
        <div class="self-center md:justify-start pt-s md:pt-0">
          <slot name="action" />
        </div>
      </div>
    </div>
  </IadWrapper>
</template>
